<template>
  <ol
    :class="['school-new-breadcrumbs', { 'school-new-breadcrumbs--borders' :borders }]"
    itemscope
    itemtype="https://schema.org/BreadcrumbList"
  >
    <li
      v-for="(item, idx) in breadcrumbs"
      :key="idx"
      class="school-new-breadcrumbs__item"
      itemprop="itemListElement"
      itemscope
      itemtype="https://schema.org/ListItem"
    >
      <nuxt-link
        :to="item.to"
        class="school-new-breadcrumbs__link"
        itemprop="item"
      >
        <span
          itemprop="name"
          v-html="item.text"
        />
        <meta
          :content="idx + 1"
          itemprop="position"
        >
      </nuxt-link>
    </li>
  </ol>
</template>

<script>
export default {
  name: 'SchoolNewBreadcrumbs',
  props: {
    breadcrumbs: {
      type: Array,
      required: true,
    },
    borders: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped lang="scss">

.school-new-breadcrumbs {
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  padding-block: calc(var(--scale) * 10);
  gap: calc(var(--scale) * 2) calc(var(--scale) * 12);

  @include media-down($size-tablet) {
    gap: calc(var(--scale) * 2) calc(var(--scale) * 8);
  }

  .school-new-breadcrumbs__item {
    display: flex;
    align-items: center;
    gap: calc(var(--scale) * 12);
    position: relative;

    @include media-down($size-tablet) {
      gap: calc(var(--scale) * 8);
    }

    &:before {
      content: '';
      width: 0;
      height: 1px;
      background-color: #A7ABAC;
      position: absolute;
      left: 0;
      bottom: calc(var(--scale) * 10);
      transition: 200ms;
    }

    &:not(:last-of-type):after {
      content: '';
      flex-shrink: 0;
      display: block;
      width: calc(var(--scale) * 10);
      aspect-ratio: 1/1;
      background-image: url("/v2/school-new/breadcrumbs-arrow.svg");
      background-size: cover;

      @include media-down($size-tablet) {
        width: calc(var(--scale) * 8);
      }
    }

    @media (hover: hover) {
      &:not(:last-of-type):hover:before {
        width: calc(100% - var(--scale) * 22);

        @include media-down($size-tablet) {
          width: calc(100% - var(--scale) * 16);
        }
      }
    }

    &:last-of-type .school-new-breadcrumbs__link {
      cursor: default;
    }

    .school-new-breadcrumbs__link {
      padding-block: calc(var(--scale) * 10);
      font-weight: 400;
      font-size: calc(var(--scale) * 20);
      line-height: 130%;
      color: #A7ABAC;

      @include media-down($size-tablet) {
        padding-block: calc(var(--scale) * 4);
        font-weight: 500;
        font-size: calc(var(--scale) * 14);
        color: #919191;
      }
    }
  }

  &--borders {
    border-top: 1px solid #CACACB;
    border-bottom: 1px solid #CACACB;
    padding-inline: calc(var(--scale) * 40);
    padding-block: calc(var(--scale) * 24);

    @include media-down($size-tablet) {
      padding-inline: calc(var(--scale) * 16);
      padding-block: calc(var(--scale) * 12);
    }
  }
}

</style>
